package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ParentStudentSummary(
    @SerialName("student_id")
    val studentId: String? = null,
    @SerialName("student_name")
    val studentName: String? = null,
    @SerialName("admission_number")
    val admissionNumber: String? = null,
    @SerialName("class_name")
    val className: String? = null,
    @SerialName("section_name")
    val sectionName: String? = null,
    @SerialName("relationship_type")
    val relationshipType: String? = null,
    @SerialName("is_primary_contact")
    val isPrimaryContact: Boolean = false
)

@Serializable
data class ParentListResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("name")
    val name: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null,
    @SerialName("primary_contact_phone")
    val primaryContactPhone: String? = null,
    @SerialName("primary_contact_email")
    val primaryContactEmail: String? = null,
    @SerialName("secondary_contact_phone")
    val secondaryContactPhone: String? = null,
    @SerialName("secondary_contact_email")
    val secondaryContactEmail: String? = null,
    @SerialName("students")
    val students: List<ParentStudentSummary>? = null
)
